import type { ReactNode } from 'react';

export const symbol_3d: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M520-357h135q26.81 0 45.91-19.09Q720-395.19 720-422v-116q0-26.81-19.09-45.91Q681.81-603 655-603H520v246Zm50-50v-146h85q6 0 10.5 4.5T670-538v116q0 6-4.5 10.5T655-407h-85Zm-190 47q14 0 27-13t13-27v-40q0-17-11.5-28.5T380-480q17 0 28.5-11.5T420-520v-40q0-14-13-27t-27-13H275q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7h95v45h-49q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7h49v45h-95q-10.83 0-17.92 7.12-7.08 7.11-7.08 18 0 10.88 7.08 17.88 7.09 7 17.92 7h105ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
